import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import DashboardWrapper from "../../components/DashboardWrapper";
import CrudForm from "../../components/dashboard/form/CrudForm";
import productService from "../../services/productService";
import Swal from "sweetalert2";

export default function EditHomeSection() {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();

  // ✅ Get section from state if available
  const [section, setSection] = useState(location.state?.section || null);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const res = await productService.getAllProducts();
      const productsArray = Array.isArray(res.data)
        ? res.data
        : res.data?.data || [];
      setProducts(productsArray);
    } catch (err) {
      console.error(err);
    }
  };

  const handleSubmit = async (formData) => {
    try {
      const payload = {
        name: formData.name,
        sort_order: Number(formData.sort_order),
        status: Number(formData.status),
        products: (formData.products || []).map((p) =>
          typeof p === "object" ? p.id : p,
        ),
      };

      await productService.updateHomeSection(id, payload);

      Swal.fire({
        icon: "success",
        title: "Updated!",
        text: "Section updated successfully",
        confirmButtonColor: "#FB6C22",
      });

      navigate("/admin/home-section-products");
    } catch (err) {
      Swal.fire("Error!", err.message || "Something went wrong", "error");
    }
  };

  if (!section) {
    // Fallback: if no state passed, you can fetch it, but it won't show loading
    return <div className="p-5 text-center">Section not found!</div>;
  }

  return (
    <DashboardWrapper>
      <div className="container mt-4">
        <h4>Edit Home Section</h4>

        <CrudForm
          initialData={{
            name: section.name,
            // sort_order: section.sort_order,
            status: section.status,
            products: section.products || [],
          }}
          onSubmit={handleSubmit}
          allowedFields={["name", "status", "products"]}
          customFields={{ products: { type: "multi-select" } }}
          products={products}
        />
      </div>
    </DashboardWrapper>
  );
}
